import { Button } from 'primereact/button';
import { PickList } from 'primereact/picklist';
import { BlockUI } from 'primereact/blockui';
import { useEffect, useState } from 'react';

import {
    obtieneUsuarios,
    obtieneUsuariosPuesto,
    registraUsuariosPuesto
} from '../../services/Siniestro/SiniestroService';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Checkbox } from 'primereact/checkbox';

const AsignaUsuarios = ({ datosPuesto, funcSalir, toast }) => {
    //console.log('DATOS PUESTO...:', datosPuesto);
    const [origen, setOrigen] = useState([]);
    const [destino, setDestino] = useState([]);
    const [procesando, setProcesando] = useState(false);
    const [cargando, setCargando] = useState(false);

    const onChange = (event) => {
        setOrigen(event.source);
        setDestino(event.target);
    };

    useEffect(() => {
        const recuperaTodoUsuario = async () => {
            try {
                setCargando(true);
                const datos = await obtieneUsuarios();
                const datosAdd = datos.map((item) => ({ ...item, soloCorreo: false }));
                //setOrigen(datos);
                // ahora recupera los usuarios
                const usuDatos = await obtieneUsuariosPuesto(datosPuesto?.configuracionDetId);
                //console.log('DESTINO.... : ', usuDatos);
                setDestino(usuDatos);

                const idsB = new Set(usuDatos.map((usuario) => usuario.usuarioId));
                const idsASinB = datosAdd.filter((usuario) => !idsB.has(usuario.usuarioId));

                setOrigen(idsASinB);
            } catch (error) {
                console.error('Error al recuperar Usuarios');
            } finally {
                setCargando(false);
            }
        };
        recuperaTodoUsuario();
    }, [datosPuesto?.configuracionDetId]);

    const toogleSoloCorreo = (item) => {
        const nuevoDestino = destino.map((u) => {
            if (u.usuarioId === item.usuarioId) {
                return { ...u, soloCorreo: !u.soloCorreo };
            }
            return u;
        });
        setDestino(nuevoDestino);
    };


    /*  //anterior
    const itemTemplate = (item) => {
        return (
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                <div>
                    <span className="font-bold">{item.username}</span>
                    <div className="text-sm text-color-secondary">{item.nombre}</div>
                </div>
            </div>
        );
    };*/
    const itemTemplate = (item) => {
        const esAsignado = destino.some(u => u.usuarioId === item.usuarioId);
        return (
        <div className="flex align-items-center justify-content-between w-full" style={{ minHeight: '30px' }}>
            
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                <div>
                    <span className="font-bold">{item.username}</span>
                    <div className="text-sm text-color-secondary">{item.nombre}</div>
                </div>
            </div>
            
            {/* Solo si está en la derecha, renderizamos el Checkbox */}
            {esAsignado && (
                <div 
                    className="flex align-items-center" 
                    onClick={(e) => e.stopPropagation()} // Evita que se seleccione la fila al hacer click en el check
                >
                    <label 
                        htmlFor={`ch_${item.usuarioId}`} 
                        className="mr-2 text-sm text-600"
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                        Solo enviar correo
                    </label>
                    <Checkbox
                        inputId={`ch_${item.usuarioId}`}
                        onChange={() => toogleSoloCorreo(item)} 
                        checked={item.soloCorreo || false} 
                    />
                </div>
            )}
        </div>
    );
    }

    const handleGuardar = async () => {
        //console.log('GUARDANDO.....');
        try {
            //console.log ('PARA GRABAR..: ', destino)
            setProcesando(true);
            const datosPost = destino.map(item => ({
                usuarioId: item.usuarioId,
                activo: item.activo,
                contrasena: "",
                estado: item.estado,
                fechaIngreso: item.fechaIngreso,
                nombre: item.nombre,
                username: item.username,
                correo: "",
                correo_electronico: "",
                correo_electronico_copia: "",
                soloCorreo: item.soloCorreo
            }))
            const datos = await registraUsuariosPuesto(datosPost, datosPuesto?.configuracionDetId);
            if (datos.length !== 0) {
                //console.log('GUARDADO CON EXITO');
                toast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se han guardado los cambios'
                });
            }
        } catch (error) {
            //console.error('Error al registrar los cambios');
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al registrar los cambios'
            });
        } finally {
            setProcesando(false);
            funcSalir();
        }
    };

    return (
        <div className="card">
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-3">
                    <label>Puesto descripcion: </label>
                </div>
                <div className="field col-12 md:col-9">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                        {datosPuesto.nombre}
                    </span>
                </div>
                <div className="field col-12 md:col-12">
                    <BlockUI
                        blocked={cargando}
                        template={<ProgressSpinner style={{ width: '50px', height: '50px' }} />}
                    >
                        <PickList
                            source={origen}
                            target={destino}
                            onChange={onChange}
                            dataKey="usuarioId"
                            itemTemplate={itemTemplate}
                            sourceHeader="Usuarios Disponibles"
                            targetHeader="Usuarios Asignados"
                            showSourceFilter={true}
                            showTargetFilter={true}
                            sourceFilterPlaceholder="Buscar por nombre"
                            targetFilterPlaceholder="Buscar por nombre"
                            filterBy="username"
                            showSourceControls={false}
                            showTargetControls={false}
                            breakpoint="1000px"
                        />
                    </BlockUI>
                </div>
                <div className="field col-12 md:col-9">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-12 md:col-3">
                    <Button
                        icon="pi pi-save"
                        label="Guardar"
                        onClick={handleGuardar}
                        loading={procesando}
                    />
                </div>
            </div>
        </div>
    );
};

export default AsignaUsuarios;
